import { IconV2 } from 'components/common/IconV2/IconV2';
import type { MediumIconV2Props } from 'components/common/IconV2/IconV2.types';

const ShoppingCartIcon = (props: MediumIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 32 32">
    <path
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M22.646 13.938V9.125a6.646 6.646 0 0 0-13.292 0v4.813M23.333 27.23h4.583M25.625 24.938v4.583"
    />
    <path stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M28 20.243V9.333H4v20h14.204" />
  </IconV2>
);

export default ShoppingCartIcon;
